import React from "react";
import "./Dashboardheader.css";
import PDF from "../CommonPDF/PDF";
import PrescriptionDetailView from "../PrescriptionDetailView/PrescriptionDetailView";
import PharmacyEntryMaster from "./PharmacyEntryMaster";
import Prescriptionsave from "./Prescriptionsave";
import axiosInstance from "../../api/axiosInstance";
import Cookies from "js-cookie";
import { apiurl } from "../../App";
import { initEncryptionSession } from "../../encryptionSession";
import { encryptData, decryptData } from "../Crypto_Helpers/cryptoHelper";
import ShowNotification from "../ShowNotification/ShowNotification";
import { withTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import MedicineModal from "./MedicineModal";
import dateFormat from "dateformat";
import {
  HiOutlineEye,
  HiOutlineDocumentDownload,
  HiOutlineRefresh,
  HiOutlinePlusCircle,
  HiOutlineCheckCircle,
} from "react-icons/hi";

const headRows = [
  { id: "sno", label: "S.No", typeDt: "sno" },
  { id: "presid", label: "Prescription ID" },
  { id: "customer", label: "Name", typeDt: "str" },
  { id: "customer_phno", label: "Member Phone no" },
  { id: "doctorName", label: "Doctor", typeDt: "str" },
  { id: "prescribed_on", label: "Prescribed on", typeDt: "date" },
  { id: "status", label: "Status", typeDt: "str" },
  { id: "billed_amount", label: "Rate", typeDt: "amt", type: "amt" },
];

class PrescriptionMasterview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      props_loading: false,
      openview: false,
      open: false,
      addopen: false,
      tableData: [],
      prescriptionEntryData: null,
      fromDate: "",
      toDate: "",
      selected_doctor_id: 0,
      selected_status: 0,
      prescriptionopenview: false,
      visible: false,
      successmsg: "",
      issuccess: false,
      medicineList: null,
      pdfData: null,
      isModalOpen: false,
      startDate: dateFormat(new Date(), "yyyy-mm-dd"),
      endDate: dateFormat(new Date(), "yyyy-mm-dd"),
      page: 1,
      rowsPerPage: 25,
    };
    this.pdfRef = React.createRef();
  }

  componentDidMount() {
    // Check if we navigated here with a specific prescription to open (from Send Quote in dashboard)
    const searchParams = new URLSearchParams(this.props.location?.search || "");
    const autoOpenId = searchParams.get("id");
    this.getTableData(autoOpenId ? Number(autoOpenId) : null);
    this.intervalId = setInterval(() => {
      this.getTableData();
    }, 120000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  viewmedicineList = (data) => {
    this.setState({
      pdfData: data,
      medicineList: data.p_medicinedetails,
      isModalOpen: true,
    });
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  getTableData = async (autoOpenId = null) => {
    this.setState({ props_loading: true });
    try {
      const aesKey = await initEncryptionSession();
      const pharmacyId =
        localStorage.getItem("pharmacy_id") ||
        Cookies.get("pharmacy_id") ||
        0;
      const payload = {
        pharmacy_id: pharmacyId,
        from_date: this.state.startDate,
        to_date: this.state.endDate,
      };
      const encryptedPayload = await encryptData(payload, aesKey);
      const response = await axiosInstance({
        method: "POST",
        url: apiurl + "pharmacy/getPharmDashboard",
        data: { objects: encryptedPayload },
      });

      const rawTransaction = response.data?.data?.[0]?.today_transaction;
      const transactions =
        rawTransaction && typeof rawTransaction === "string"
          ? await decryptData(rawTransaction, aesKey)
          : Array.isArray(rawTransaction)
          ? rawTransaction
          : [];

      const sortedTransactions = [...transactions].sort((a, b) => {
        const idA = Number(a.prescription_id || a.id || 0);
        const idB = Number(b.prescription_id || b.id || 0);
        return idB - idA;
      });

      const tableData = [];
      sortedTransactions.forEach((val) => {
        tableData.push({
          orderId: val.custom_order_id,
          customer: val.customer,
          gender: val.gender,
          customer_phno: val.phone_no,
          doctorName: val.doctor_name,
          status: val.status,
          id: val.prescription_id,
          rawItem: val,
        });
      });

      this.setState({
        props_loading: false,
        tableData: tableData,
        totalData: sortedTransactions,
      }, () => {
        // Auto-open prescription if navigated via Send Quote from dashboard
        if (autoOpenId) {
          const target = sortedTransactions.find(v => String(v.prescription_id) === String(autoOpenId));
          if (target) {
            this.modelopen("add", autoOpenId);
          }
        }
      });
    } catch (error) {
      console.error("Dashboardheader getTableData error:", error);
      this.setState({ props_loading: false });
    }
  };

  downloadInvoice = (data) => {
    this.setState(
      {
        pdfData: data,
        medicineList: typeof data?.p_medicinedetails === "string" ? JSON.parse(data?.p_medicinedetails || "[]") : data?.p_medicinedetails || [],
      },
      () => {
        if (this.pdfRef && this.pdfRef.generatePdf) {
          this.pdfRef.generatePdf();
        }
      }
    );
  };

  searchChange = (e) => {
    this.setState({
      search: e.target.value,
      page: 1,
    });
  };

  modelopen = (data, id) => {
    let prescriptionEntryData = (this.state.totalData || []).filter(
      (val) => val.prescription_id === id
    );
    if (
      prescriptionEntryData.length > 0 &&
      !prescriptionEntryData[0].medicines
    ) {
      prescriptionEntryData[0].medicines = [];
    }

    if (data === "view") {
      this.setState({
        prescriptionopenview: true,
        prescriptionEntryData: prescriptionEntryData,
      });
    } else if (data === "add") {
      this.setState({
        addopen: true,
        prescriptionEntryData: prescriptionEntryData,
      });
    }
  };

  closemodal = () => {
    this.setState({ openview: false, addopen: false });
  };

  handleClose = () => {
    this.setState({ openview: false, prescriptionopenview: false });
  };

  getBack = () => {
    this.setState({
      addopen: !this.state.addopen,
    });
  };

  getBackView = () => {
    this.setState({
      openview: !this.state.openview,
    });
  };

  handleopenSuccess = (successmsg, issuccess) => {
    this.setState({ visible: true, successmsg, issuccess });
  };

  handleCloseSuccess = () => {
    this.setState({ visible: false });
  };

  render() {
    const { t } = this.props;
    const { search, tableData, page, rowsPerPage, isModalOpen, props_loading } = this.state;

    const searchStr = (search || "").trim().toLowerCase();
    const searchData = tableData.filter((data) => {
      if (!searchStr) return true;
      return (
        (data.orderId && data.orderId.toLowerCase().includes(searchStr)) ||
        (data.customer && data.customer.toLowerCase().includes(searchStr)) ||
        (data.customer_phno &&
          data.customer_phno.toString().toLowerCase().includes(searchStr)) ||
        (data.doctorName &&
          data.doctorName.toLowerCase().includes(searchStr)) ||
        (data.status && data.status.toLowerCase().includes(searchStr))
      );
    });

    const currentPage = page || 1;
    const pageSize = rowsPerPage || 25;
    const totalPages = Math.ceil(searchData.length / pageSize) || 1;
    const paginatedData = searchData.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );

    const getPageNumbers = (current, total) => {
      if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
      let start = Math.max(1, current - 2);
      let end = Math.min(total, start + 4);
      if (end - start < 4) start = Math.max(1, end - 4);
      const pages = [];
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    };

    const pageNumbers = getPageNumbers(currentPage, totalPages);
    const startPage = pageNumbers[0];
    const endPage = pageNumbers[pageNumbers.length - 1];

    return (
      <div className="p-4 sm:p-5 max-w-[1600px] mx-auto space-y-4 sm:space-y-5 animate-fadeIn">
        {this.state.isModalOpen === true ? (
          <MedicineModal
            data={this.state.medicineList}
            pdfData={this.state.pdfData}
            onClose={this.handleCloseModal}
            downloadInvoice={this.downloadInvoice}
            tittle="Today's Prescription"
            t={t}
            i18n={this.props.i18n}
          />
        ) : this.state.addopen === true ? (
          <PharmacyEntryMaster
            prescriptionEntryData={this.state.prescriptionEntryData}
            getBack={() => this.getBack()}
            getTableData={() => this.getTableData()}
            handleopenSuccess={this.handleopenSuccess}
            downloadInvoice={this.downloadInvoice}
            label={t("prescription")}
            t={t}
            i18n={this.props.i18n}
          />
        ) : this.state.openview === true &&
          this.state.prescriptionEntryData !== null &&
          this.state.prescriptionEntryData[0]?.file_name === null ? (
          <Prescriptionsave
            prescriptionEntryData={this.state.prescriptionEntryData}
            getBackView={() => this.getBackView()}
            t={t}
            i18n={this.props.i18n}
          />
        ) : (
          <>
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 bg-white p-3.5 sm:p-4 rounded-xl border border-gray-100 shadow-2xs">
              <div className="flex items-center gap-3">
                <NavLink
                  to="/Home/dashboard"
                  className="w-8 h-8 rounded-lg bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white flex items-center justify-center transition-all duration-300 shadow-2xs active:scale-95 group"
                  title="Back to Dashboard"
                >
                  <svg
                    className="w-4 h-4 stroke-[2.5] transform group-hover:-translate-x-0.5 transition-transform"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                </NavLink>
                <div>
                  <div className="flex items-center gap-2">
                    <h1 className="text-base sm:text-lg font-bold text-gray-900 tracking-tight">
                      Today's <span className="text-teal-600">Prescriptions</span>
                    </h1>
                    <span className="px-2 py-0.5 rounded-full bg-teal-50 text-teal-700 text-[10px] font-bold border border-teal-100">
                      {searchData.length}{" "}
                      {searchData.length === 1 ? "patient" : "patients"}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 font-medium mt-0.5">
                    Real-time queue of today's incoming patient prescriptions and medicine dispensing
                  </p>
                </div>
              </div>

              <div className="relative min-w-[240px]">
                <input
                  type="text"
                  placeholder="Search patient, ID, phone..."
                  value={search}
                  onChange={this.searchChange}
                  className="w-full pl-9 pr-3 py-1.5 rounded-lg border border-gray-300 bg-gray-50/50 focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all"
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                  <svg
                    className="w-3.5 h-3.5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <PDF
              ref={(ref) => (this.pdfRef = ref)}
              pdfData={this.state.pdfData}
              weekMonthYearData={this.state.medicineList}
              headRows={headRows}
              filename="Today Prescriptions"
              headingTitle="Today's Prescriptions"
            />

            <div className="bg-white rounded-xl border border-gray-100 shadow-2xs overflow-hidden flex flex-col">
              <div className="overflow-x-auto w-full">
                <table className="w-full text-left border-collapse min-w-[950px]">
                  <thead>
                    <tr className="bg-slate-50/90 border-b border-gray-200 text-xs font-bold text-slate-700 uppercase tracking-wider select-none">
                      <th className="py-2.5 px-3 text-center w-12 shrink-0">S.No</th>
                      <th className="py-2.5 px-3 text-center w-36 whitespace-nowrap">Prescription ID</th>
                      <th className="py-2.5 px-4 text-left min-w-[180px] whitespace-nowrap">Patient Name</th>
                      <th className="py-2.5 px-3 text-center w-24 whitespace-nowrap">Gender</th>
                      <th className="py-2.5 px-3 text-center w-36 whitespace-nowrap">Phone No</th>
                      <th className="py-2.5 px-4 text-left min-w-[200px] whitespace-nowrap">Prescribed By</th>
                      <th className="py-2.5 px-3 text-center w-32 whitespace-nowrap">Medicines</th>
                      <th className="py-2.5 px-3 text-center w-32 whitespace-nowrap">Status</th>
                      <th className="py-2.5 px-3 text-center w-36 whitespace-nowrap">Action</th>
                      <th className="py-2.5 px-3 text-center w-28 whitespace-nowrap">Invoice</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 text-xs sm:text-sm">
                    {props_loading ? (
                      <tr>
                        <td colSpan={10} className="py-12 text-center text-gray-400 font-medium">
                          <div className="flex flex-col items-center justify-center gap-2">
                            <div className="w-6 h-6 border-2 border-teal-600 border-t-transparent rounded-full animate-spin" />
                            <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">
                              Loading today's prescriptions...
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan={10} className="py-12 text-center text-gray-400 font-medium">
                          <div className="flex flex-col items-center justify-center gap-1.5">
                            <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-300 text-xl">
                              📋
                            </div>
                            <p className="text-sm font-bold text-slate-700">No prescriptions found today</p>
                            <p className="text-xs text-slate-400">
                              {search ? "No records match your search criteria" : "New prescriptions will appear here in real time"}
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((data, index) => {
                        const rowNumber = (currentPage - 1) * pageSize + index + 1;
                        const isQuotePending = !data.status || data.status === "Quote Pending";
                        const isCanceled = data.status === "Canceled";
                        const isDelivered = data.status === "Delivered" || data.status === "Completed";
                        return (
                          <tr
                            key={data.id || index}
                            className="hover:bg-teal-50/20 transition-colors group"
                          >
                            <td className="py-2.5 px-3 text-center text-xs font-bold text-slate-500">
                              {rowNumber}
                            </td>
                            <td className="py-2.5 px-3 text-center">
                              <span className="px-2.5 py-1 rounded-lg bg-teal-50 text-teal-800 font-mono text-xs font-bold border border-teal-100">
                                #{data.orderId}
                              </span>
                            </td>
                            <td className="py-2.5 px-4 text-left font-bold text-slate-900 text-xs sm:text-sm">
                              {data.customer || "Walk-in Patient"}
                            </td>
                            <td className="py-2.5 px-3 text-center">
                              <span className="px-2 py-0.5 rounded-md bg-slate-100 text-slate-800 text-xs font-bold uppercase">
                                {data.gender || "-"}
                              </span>
                            </td>
                            <td className="py-2.5 px-3 text-center text-xs font-semibold text-slate-700 font-mono">
                              {data.customer_phno || "-"}
                            </td>
                            <td className="py-2.5 px-4 text-left">
                              <div className="flex items-center gap-2">
                                <div className="w-6.5 h-6.5 rounded-full bg-teal-100/70 text-teal-800 flex items-center justify-center text-xs font-bold shrink-0">
                                  {(data.doctorName || "D")[0]}
                                </div>
                                <span className="font-bold text-slate-900 text-xs">
                                  {data.doctorName || "Direct Pharmacy Entry"}
                                </span>
                              </div>
                            </td>
                            <td className="py-2.5 px-3 text-center">
                              <button
                                type="button"
                                onClick={() => this.viewmedicineList(data.rawItem)}
                                className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white text-xs font-bold transition-all cursor-pointer shadow-2xs active:scale-95"
                              >
                                <HiOutlineEye size={15} />
                                <span>View List</span>
                              </button>
                            </td>
                            <td className="py-2.5 px-3 text-center text-xs">
                              <button
                                type="button"
                                disabled={isCanceled}
                                onClick={() => {
                                  if (isCanceled) return;
                                  if (isQuotePending) {
                                    this.modelopen("add", data.id);
                                  } else {
                                    this.modelopen("view", data.id);
                                  }
                                }}
                                className={`px-2.5 py-1 rounded-full text-xs font-bold inline-flex items-center justify-center gap-1.5 shadow-2xs transition-all ${
                                  isCanceled
                                    ? "bg-red-50 text-red-700 border border-red-200 cursor-default"
                                    : isQuotePending
                                    ? "bg-amber-50 hover:bg-amber-100 text-amber-800 border border-amber-300 cursor-pointer active:scale-95"
                                    : data.status === "Pending Approval"
                                    ? "bg-blue-50 hover:bg-blue-100 text-blue-800 border border-blue-200 cursor-pointer active:scale-95"
                                    : isDelivered
                                    ? "bg-emerald-50 hover:bg-emerald-100 text-emerald-800 border border-emerald-200 cursor-pointer active:scale-95"
                                    : "bg-purple-50 hover:bg-purple-100 text-purple-800 border border-purple-200 cursor-pointer active:scale-95"
                                }`}
                                title={isQuotePending ? "Click to Send Quote" : "Click to View/Update Status"}
                              >
                                <span
                                  className={`w-1.5 h-1.5 rounded-full ${
                                    isCanceled
                                      ? "bg-red-500"
                                      : isQuotePending
                                      ? "bg-amber-500 animate-pulse"
                                      : data.status === "Pending Approval"
                                      ? "bg-blue-500"
                                      : isDelivered
                                      ? "bg-emerald-500"
                                      : "bg-purple-500"
                                  }`}
                                />
                                {data.status || "Quote Pending"}
                              </button>
                            </td>
                            <td className="py-2.5 px-3 text-center">
                              {isCanceled ? (
                                <span className="text-xs text-gray-400 font-medium">-</span>
                              ) : isQuotePending ? (
                                <button
                                  type="button"
                                  onClick={() => this.modelopen("add", data.id)}
                                  className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-teal-600 hover:bg-teal-700 text-white text-xs font-bold transition-all cursor-pointer shadow-xs active:scale-95 whitespace-nowrap"
                                  title="Create & Send Medicine Quote to Patient"
                                >
                                  <HiOutlinePlusCircle size={15} />
                                  <span>Send Quote</span>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => this.modelopen("view", data.id)}
                                  className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-indigo-50 hover:bg-indigo-600 text-indigo-700 hover:text-white text-xs font-bold transition-all cursor-pointer shadow-2xs active:scale-95 whitespace-nowrap"
                                  title="Track & Update Order Delivery Status"
                                >
                                  <HiOutlineRefresh size={15} />
                                  <span>Update Status</span>
                                </button>
                              )}
                            </td>
                            <td className="py-2.5 px-3 text-center">
                              {isCanceled ? (
                                <span className="text-xs text-gray-400 font-medium">-</span>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => this.downloadInvoice(data.rawItem)}
                                  className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-slate-100 hover:bg-slate-800 text-slate-700 hover:text-white text-xs font-bold transition-all cursor-pointer shadow-2xs active:scale-95"
                                  title="Download Invoice PDF"
                                >
                                  <HiOutlineDocumentDownload size={15} />
                                  <span>Invoice</span>
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              {/* Modern Orderly Pagination Footer */}
              {searchData.length > 0 && (
                <div className="flex flex-col md:flex-row items-center justify-between gap-3 px-4 sm:px-6 py-3.5 border-t border-gray-100 bg-slate-50/50 text-xs sm:text-sm">
                  <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 text-slate-600 font-medium">
                    <span className="whitespace-nowrap">
                      Showing{" "}
                      <span className="font-bold text-slate-900">
                        {(currentPage - 1) * pageSize + 1}
                      </span>{" "}
                      to{" "}
                      <span className="font-bold text-slate-900">
                        {Math.min(currentPage * pageSize, searchData.length)}
                      </span>{" "}
                      of{" "}
                      <span className="font-bold text-slate-900">
                        {searchData.length}
                      </span>{" "}
                      patients
                    </span>
                    <div className="flex items-center gap-1.5 ml-2 whitespace-nowrap">
                      <span className="font-semibold text-slate-700">Rows:</span>
                      <select
                        value={pageSize}
                        onChange={(e) =>
                          this.setState({
                            rowsPerPage: Number(e.target.value),
                            page: 1,
                          })
                        }
                        className="px-2 py-1 bg-white border border-gray-200 rounded-lg text-xs font-bold text-slate-700 outline-none cursor-pointer focus:border-teal-500"
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                  </div>

                  {/* Page navigation buttons */}
                  <div className="flex items-center gap-1 sm:gap-1.5 flex-wrap justify-center">
                    <button
                      type="button"
                      disabled={currentPage === 1}
                      onClick={() => this.setState({ page: currentPage - 1 })}
                      className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                        currentPage === 1
                          ? "text-slate-300 bg-transparent cursor-not-allowed border border-transparent"
                          : "text-slate-700 bg-white hover:bg-teal-50 hover:text-teal-700 border border-gray-200 cursor-pointer shadow-2xs"
                      }`}
                    >
                      Previous
                    </button>

                    {startPage > 1 && (
                      <>
                        <button
                          type="button"
                          onClick={() => this.setState({ page: 1 })}
                          className="w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                        >
                          1
                        </button>
                        {startPage > 2 && <span className="text-slate-400 text-xs px-0.5 select-none">...</span>}
                      </>
                    )}

                    {pageNumbers.map((pageNum) => (
                      <button
                        key={pageNum}
                        type="button"
                        onClick={() => this.setState({ page: pageNum })}
                        className={`w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer ${
                          currentPage === pageNum
                            ? "bg-teal-600 text-white shadow-xs shadow-teal-600/30"
                            : "bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                        }`}
                      >
                        {pageNum}
                      </button>
                    ))}

                    {endPage < totalPages && (
                      <>
                        {endPage < totalPages - 1 && <span className="text-slate-400 text-xs px-0.5 select-none">...</span>}
                        <button
                          type="button"
                          onClick={() => this.setState({ page: totalPages })}
                          className="w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                        >
                          {totalPages}
                        </button>
                      </>
                    )}

                    <button
                      type="button"
                      disabled={currentPage === totalPages}
                      onClick={() => this.setState({ page: currentPage + 1 })}
                      className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                        currentPage === totalPages
                          ? "text-slate-300 bg-transparent cursor-not-allowed border border-transparent"
                          : "text-slate-700 bg-white hover:bg-teal-50 hover:text-teal-700 border border-gray-200 cursor-pointer shadow-2xs"
                      }`}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {this.state.prescriptionopenview && (
          <PrescriptionDetailView
            prescriptionopenview={this.state.prescriptionopenview}
            onClose={this.handleClose}
            xswidth={"xs"}
            prescriptionEntryData={this.state.prescriptionEntryData}
            getTableData={() => this.getTableData()}
            is_from_pending_orders={true}
            handleopenSuccess={this.handleopenSuccess}
            t={t}
            i18n={this.props.i18n}
            fromData="pendingOrders"
          />
        )}
        <ShowNotification
          visible={this.state.visible}
          successmsg={this.state.successmsg}
          issuccess={this.state.issuccess}
          handleCloseSuccess={this.handleCloseSuccess}
          t={t}
          i18n={this.props.i18n}
        />
      </div>
    );
  }
}

export default withTranslation()(PrescriptionMasterview);
